import { useMemo } from 'react';

import type { Receiver } from '../../generated-types';
import useTranslation, { format } from '../../hooks/useTranslation';

const findAccount = (receivers: Receiver[] | undefined, accountNumber: string) =>
    receivers?.find((receiver) => receiver.accountNumber.value === accountNumber);

export default (
    accountNumberList: string[],
    accountNumberSanitized: string,
    receiver: Receiver,
    receivers: Receiver[],
): string | undefined => {
    const translated = useTranslation();
    return useMemo(
        () =>
            accountNumberList?.includes(accountNumberSanitized) &&
            accountNumberSanitized !== receiver.accountNumber.value
                ? format(
                      translated.paymentValidation.existingAccountNumber,
                      findAccount(receivers, accountNumberSanitized)!.name,
                  )
                : undefined,
        [
            accountNumberList,
            accountNumberSanitized,
            receiver.accountNumber.value,
            receivers,
            translated.paymentValidation.existingAccountNumber,
        ],
    );
};
